import schedule from './schedule/actions'
import scale from './scale/actions'

const data = {
	schedule,
	scale
}

export default data
